module.exports = __webpack_public_path__ + "static/img/Logo_Walbing_symbol.62f0e04a.svg";